import { useEffect, useState } from "react";
import * as ClubManagamentApi from "../../../services/club.service";
import { Link, useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../../common/breadcrumbs";
import { formateDate } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder } from "rsuite";
import { SOCKET_CLIENT } from "../../../../../utils/socket";

const ClubManagamentDetails = () => {
    const params = useParams();
    const [showdefault, setShowDefault] = useState({});
    const { t } = useTranslation();
    const navigate = useNavigate();

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: t("Club Management"), url: "/admin/club-management/club/list/1" },
        { title: t("btn_view"), url: "" },
    ];

    useEffect(() => {
        let isMounted = true;
        let socketSettings = null;

        ClubManagamentApi.Details(params.id).then((response) => {
            if (isMounted) {
                setShowDefault((prev) => {
                    const data = response?.data || {};
                    return {
                        ...data,
                        showLeaderboardParent: socketSettings !== null ? socketSettings.showLeaderboardParent : Boolean(data.showLeaderboardParent),
                        showLeaderboardPlayer: socketSettings !== null ? socketSettings.showLeaderboardPlayer : Boolean(data.showLeaderboardPlayer),
                    };
                });
            }
        });

        if (params.id) {
            console.log(`📡 Joining Club Socket Room: ${params.id}`);
            SOCKET_CLIENT.emit("JOIN_CLUB", { clubId: params.id });

            const handleLeaderboardUpdate = (socketData) => {
                console.log("🔥 Leaderboard Settings Update Received via Socket:", socketData);
                if (socketData?.data) {
                    socketSettings = {
                        showLeaderboardParent: socketData.data.showLeaderboardParent,
                        showLeaderboardPlayer: socketData.data.showLeaderboardPlayer,
                    };
                    setShowDefault((prev) => ({
                        ...prev,
                        showLeaderboardParent: socketData.data.showLeaderboardParent,
                        showLeaderboardPlayer: socketData.data.showLeaderboardPlayer,
                    }));
                }
            };

            SOCKET_CLIENT.on("LEADERBOARD_SETTINGS_UPDATE", handleLeaderboardUpdate);

            return () => {
                isMounted = false;
                console.log(`📡 Leaving Club Socket Room: ${params.id}`);
                SOCKET_CLIENT.emit("LEAVE_CLUB", { clubId: params.id });
                SOCKET_CLIENT.off("LEADERBOARD_SETTINGS_UPDATE", handleLeaderboardUpdate);
            };
        }
    }, [params.id]);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h6 className="main-content-label mb-3">
                                Club View
                            </h6>

                            {showdefault && Object.keys(showdefault).length > 0 ? (
                                <>
                                    {/* ================= CLUB VIEW ================= */}
                                    <table className="table table-bordered table-hover mb-4">
                                        <tbody>
                                            <tr>
                                                <th>{t("Profile Picture")}</th>
                                                <td>
                                                    {((showdefault?.clubDetails?.image && showdefault.clubDetails.image !== "N/A") || (showdefault?.profile_image && showdefault.profile_image !== "N/A")) ? (
                                                        <img 
                                                            style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '50%' }}
                                                            src={showdefault?.clubDetails?.image && showdefault.clubDetails.image !== "N/A" ? showdefault.clubDetails.image : showdefault.profile_image} 
                                                            alt="Profile" 
                                                        />
                                                    ) : (
                                                        <div style={{ width: '50px', height: '50px', background: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', fontSize: '10px', color: '#9ca3af' }}>
                                                            No Image
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{t("label_club_school")}</th>
                                                <td>{showdefault?.clubDetails?.name || showdefault?.name || "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>{t("label_email")}</th>
                                                <td>{showdefault?.clubDetails?.email || showdefault?.clubEmail || showdefault?.email || "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>{t("label_status")}</th>
                                                <td>
                                                    {showdefault?.status ? (
                                                        <span
                                                            className={`badge badge-pill fw-bold text-uppercase px-3 py-2 ${{
                                                                active: "badge-success-light",
                                                                inactive: "badge-danger-light",
                                                            }[showdefault.status.toLowerCase()] || "badge-secondary"
                                                                }`}
                                                        >
                                                            {showdefault.status}
                                                        </span>
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{t("label_address")}</th>
                                                <td>{showdefault?.clubDetails?.address || showdefault?.address || "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>{t("label_city")}</th>
                                                <td>{showdefault?.clubDetails?.city || showdefault?.city || "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>{t("label_state")}</th>
                                                <td>{showdefault?.clubDetails?.state || showdefault?.state || "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>{t("label_country")}</th>
                                                <td>{showdefault?.clubDetails?.country || showdefault?.country || "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>{t("label_zipcode")}</th>
                                                <td>{showdefault?.clubDetails?.zipCode || showdefault?.zipCode || showdefault?.zip || "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>{t("Leaderboard Settings (Parents)")}</th>
                                                <td>
                                                    {showdefault?.showLeaderboardParent === true ? (
                                                        <span className="badge badge-pill badge-success-light fw-bold text-uppercase px-3 py-2">
                                                            {t("Enabled")}
                                                        </span>
                                                    ) : (
                                                        <span className="badge badge-pill badge-danger-light fw-bold text-uppercase px-3 py-2">
                                                            {t("Disabled")}
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{t("Leaderboard Settings (Players)")}</th>
                                                <td>
                                                    {showdefault?.showLeaderboardPlayer === true ? (
                                                        <span className="badge badge-pill badge-success-light fw-bold text-uppercase px-3 py-2">
                                                            {t("Enabled")}
                                                        </span>
                                                    ) : (
                                                        <span className="badge badge-pill badge-danger-light fw-bold text-uppercase px-3 py-2">
                                                            {t("Disabled")}
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>{t("label_created_at")}</th>
                                                <td>{formateDate(showdefault && showdefault?.createdAt) || "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>{t("label_updated_at")}</th>
                                                <td>{formateDate(showdefault && showdefault?.updatedAt) || "N/A"}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    {/* ================= PLAYERS TABLE ================= */}
                                    <h6 className="main-content-label mb-3">
                                        {t("sidebar_link_players")}
                                    </h6>
                                    <table className="table table-bordered table-hover mt-4">
                                        <thead>
                                            <tr>
                                                <th>{t("list_heading_sno")}</th>
                                                <th>{t("label_name")}</th>
                                                <th>{t("label_email")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {showdefault?.players?.length > 0 ? (
                                                showdefault.players.map((player, index) => (
                                                    <tr key={player.id || index}>
                                                        <td
                                                            style={{
                                                                width: "80px"
                                                            }}
                                                        >{index + 1}</td>
                                                        <td>{player && player?.name ? player.name : "N/A"}</td>
                                                        <td>
                                                            <Link
                                                                to={`/admin/users-management/players/view/${player.id}`}
                                                                style={{ color: "inherit", textDecoration: "none" }}
                                                            >
                                                                {player?.email || "N/A"}
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center">
                                                        <h6>{t("label_no_data_found")}</h6>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>

                                    {/* ================= PARENTS TABLE ================= */}
                                    <h6 className="main-content-label mb-3">
                                        {t("label_parents")}
                                    </h6>
                                    <table className="table table-bordered table-hover mt-4">
                                        <thead>
                                            <tr>
                                                <th>{t("list_heading_sno")}</th>
                                                <th>{t("label_name")}</th>
                                                <th>{t("label_email")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {showdefault?.parents?.length > 0 ? (
                                                showdefault.parents.map((parent, index) => (
                                                    <tr key={parent.id || index}>
                                                        <td
                                                            style={{
                                                                width: "80px"
                                                            }}
                                                        >{index + 1}</td>
                                                        <td>{parent && parent?.name ? parent.name : "N/A"}</td>

                                                        <td>
                                                            <Link
                                                                to={`/admin/user-management/parent-admins/view/${parent.id}`}
                                                                style={{ color: "inherit", textDecoration: "none" }}
                                                            >
                                                                {parent?.email || "N/A"}
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center">
                                                        {t("msg_no_records")}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>

                                    {/* ================= TEAM MANAGERS TABLE ================= */}
                                    <h6 className="main-content-label mb-3">
                                        {t("Team Managers")}
                                    </h6>
                                    <table className="table table-bordered table-hover mt-4">
                                        <thead>
                                            <tr>
                                                <th>{t("list_heading_sno")}</th>
                                                <th>{t("label_name")}</th>
                                                <th>{t("label_email")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {showdefault?.teamManagers?.length > 0 ? (
                                                showdefault.teamManagers.map((tm, index) => (
                                                    <tr key={tm.id || index}>
                                                        <td
                                                            style={{
                                                                width: "80px"
                                                            }}
                                                        >{index + 1}</td>
                                                        <td>{tm && tm?.name ? tm.name : "N/A"}</td>

                                                        <td>
                                                            <Link
                                                                to={`/admin/user-management/team-managers/view/${tm.id}`}
                                                                style={{ color: "inherit", textDecoration: "none" }}
                                                            >
                                                                {tm?.email || "N/A"}
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center">
                                                        {t("msg_no_records")}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>

                                    {/* ================= BACK BUTTON ================= */}
                                    <div className="mt-5">
                                        <button
                                            className="btn ripple btn-dark"
                                            type="button"
                                            onClick={() => navigate(-1)}
                                        >
                                            <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                            {t("btn_back")}
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <Placeholder.Paragraph
                                    className="w-100 admin-placeholder"
                                    rowHeight={30}
                                    rowSpacing={5}
                                    active
                                    rows={7}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ClubManagamentDetails;